import { render, staticRenderFns } from "./deal-to-invoice-modal.vue?vue&type=template&id=236cc372"
import script from "./deal-to-invoice-modal.ts?vue&type=script&lang=js&external"
export * from "./deal-to-invoice-modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports